<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.5 11.9999C2.5 7.5216 2.5 5.28243 3.89124 3.89118C5.28249 2.49994 7.52166 2.49994 12 2.49994C16.4783 2.49994 18.7175 2.49994 20.1088 3.89118C21.5 5.28243 21.5 7.5216 21.5 11.9999C21.5 16.4782 21.5 18.7174 20.1088 20.1087C18.7175 21.4999 16.4783 21.4999 12 21.4999C7.52166 21.4999 5.28249 21.4999 3.89124 20.1087C2.5 18.7174 2.5 16.4782 2.5 11.9999Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M12.2422 16.9999V11.9999C12.2422 11.5285 12.2422 11.2928 12.0957 11.1463C11.9493 10.9999 11.7136 10.9999 11.2422 10.9999"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.9922 7.99994H12.0012"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>